import { FC, PropsWithChildren } from 'react';

interface ModalBodyProps {
  className?: string;
}

export const ModalBody: FC<PropsWithChildren<ModalBodyProps>> = ({
  children,
  className,
}) => {
  return <div className={className}>{children}</div>;
};
